<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zvqSKU/tc-custom/9781630475888.jpg?1704484100812" alt="This image is the cover for the book Rockstars of JVZoo.com"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rockstars of JVZoo.com
      </h1>
      <p class="bookDescription body article font2">
        <p>What Does it Take to Be an Online Rockstar</p><p></p><p>JVZoo is an amazing resource for entrepreneurs to turn their knowledge into digital products and recruit hundreds or thousands in their field to promote those products. Whether you are a business consultant, lawyer, real estate agent, or even someone who knows how to build the perfect birdhouse, JVZoo allows you to put your knowledge into a format that can be sold and profited from. While the rest of the world looks for jobs, JVZoo’s members create their own.</p><p></p><p>In the three years that JVZoo has been around, it’s members have generated over $100 million in sales revenue. Our members are mainly people who started making money online as a part-time venture.</p><p></p><p>Rockstars of JVZoo is a compilation of case studies, written by people just like you, people who listened to their inner voices and created jobs for themselves. Everything you are about to read in this book has been achieved by ordinary people who did that one thing that separates entrepreneurs from the rest of society: they took action.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joel Comm, E. Brian Rose
      </h2>
      
      <p class="authorDescription body article">Joel Comm is a New York Times Best-Selling author, internationally-known speaker and Internet pioneer. Online since 1995, Joel has inspired, equipped and entertained millions through his web sites, software, books, training and broadcasts. His previous titles include "The AdSense Code: What Google Never Told You About Making Money with AdSense", "Twitter Power 2:0: How to Dominate Your Marketing One Tweet at a Time" and "KaChing: How to Run an Online Business that Pays and Pays".</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?36f0f7af